import { isValidEmail } from '@domain-group/javascript-utils'

const state = {
  agency_id: undefined,
  contact_type: '',
  email: '',
  id: null,
  name: '',
  phone: '',
}

export const requiredFields = [
  { key: 'contact_type' },
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'name' },
  { key: 'phone' },
]

export default state
